// default states
const defaults =
{
    type: null,
    position: null,
    tab: {
        activeTab: 0,
        mainContentTab: false,
    },
};

// initial state
const state =
{
    type: defaults.type,
    position: defaults.position,
    tab: {
        activeTab: 0,
        mainContentTab: false,
    },
};

const actions =
{
    // Set type of sidebar
    setType ({commit}, type)
    {
        commit('SET_TYPE', type);
    },

    // Reset type of sidebar to default
    resetType ({commit})
    {
        commit('RESET_TYPE');
    },

    // Set position key for sidebar
    setPosition ({commit}, position)
    {
        commit('SET_POSITION', position);
    },

    // Reset position key of sidebar to default
    resetPosition ({commit})
    {
        commit('RESET_POSITION');
    },

    // Reset sidebar
    reset ({commit})
    {
        commit('RESET_TYPE');
        commit('RESET_ACTIVE_TAB');
        commit('RESET_MAIN_CONTENT_TAB');
    },

    // Set active tab index
    setActiveTab ({commit}, index)
    {
        commit('SET_ACTIVE_TAB', index);
    },

    // Set value if tabs have a content tab
    mainContentTab ({commit}, val)
    {
        commit('MAIN_CONTENT_TAB', val);
    },

};

const mutations =
{
    SET_TYPE (state, type) {
        state.type = type;
    },

    RESET_TYPE (state) {
        state.type = defaults.type;
    },

    SET_POSITION (state, position) {
        if (position == 'top') state.position = 'top';
        // else if (position == 'right') state.position = 'right';
        // else if (position == 'left') state.position = 'left';
        else state.position = 'bottom';
    },

    RESET_POSITION (state) {
        state.position = defaults.position;
    },

    SET_ACTIVE_TAB (state, index) {
        state.tab.activeTab = index;
    },

    RESET_ACTIVE_TAB (state) {
        state.tab.activeTab = defaults.tab.activeTab;
    },

    MAIN_CONTENT_TAB (state, val) {
        state.tab.mainContentTab = val;
    },

    RESET_MAIN_CONTENT_TAB (state) {
        state.tab.mainContentTab = defaults.tab.mainContentTab;
    },

};

export default
{
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/js/vuex/modules/sidebar.js